import React from 'react';

/**
 * WidgetContainer
 *
 * Wraps conversation widgets with a distinct visual style inspired by Replit's AI interface.
 * Creates clear visual separation between conversational messages and interactive widgets.
 *
 * Features:
 * - Left border accent (4px primary color)
 * - Subtle background tint (primary/5)
 * - Rounded corners matching design system
 * - Generous padding for comfortable interaction
 * - Fade-in animation from left
 */
const WidgetContainer = ({ children, className = "", ...rest }) => {
  return (
    <div
      className={`
        border-l-4 border-succession-primary 
        bg-gray-100 dark:bg-gray-800
        rounded-lg 
        p-6
        animate-in fade-in-50 slide-in-from-left-2 duration-300
        ${className}
      `}
      {...rest}
    >
      {children}
    </div>
  );
};

export default WidgetContainer;

